import { render, staticRenderFns } from "./WalletDetailsDialog.vue?vue&type=template&id=8052917c"
import script from "./WalletDetailsDialog.vue?vue&type=script&lang=js"
export * from "./WalletDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports